import { disableBatching } from '@speedlo/graphql'

import { useRoot } from '../../../app/useRoot'
import { useQPickupMap } from '../../../graph/generated'

export function usePickupMapQuery(branchId?: ID) {
  const { business } = useRoot()
  return useQPickupMap(
    {
      branchSpecific: !business.isBrand || !!branchId,
      brandId: business.brandId,
      branchId: branchId || business.branchId!,
    },
    {
      skip: !business.isValid,
      fetchPolicy: 'cache-first',
      ...disableBatching,
    },
  )
}
